import { call, put, takeEvery } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./policyInsightsConflictsGetActions";

function* policyInsightsConflictsGet(action) {
  const append = action.append === true;
  try {
    const searchParams = {};
    if (action.page) searchParams.page = action.page;
    if (action.limit) searchParams.limit = action.limit;

    const { data } = yield call(
      requestWithSubTenantIfNeeded,
      "get",
      "swg/conflicts",
      Object.keys(searchParams).length ? { searchParams } : undefined
    );

    yield put(actions.requestSuccess(data, { append }));
  } catch (error) {
    yield put(actions.requestFailure(error, { append }));
  }
}

function* saga() {
  yield takeEvery(
    actions.POLICY_INSIGHTS_CONFLICTS_GET_REQUEST,
    policyInsightsConflictsGet
  );
}

export default saga;
